<template>
  <div style="border-radius: 15px; background-color: #13b7fe; padding: 35px; ">
    <b-row>
      <b-col>
        <h4>
          <strong>
            Last Message
          </strong>
          <b-badge v-if="isPrivate" variant="light">
            Private
          </b-badge>
        </h4>
        <p>
          "{{ situation }}"
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <strong>
        -
          <date-format-toggle
              :date="date"
          />
        </strong>
      </b-col>
      <b-col md="6">
        <b-button-toolbar
            class="float-right"
            key-nav aria-label="Toolbar with button groups">
          <b-button-group
              class="mx-1">
            <b-button
                style="float: left; background-color: white; color: #13b7fe; border-radius: 10px"
                :disabled="idx <= 0"
                @click="handlePageTo(idx - 1)"
            >
              <b-icon
                  style="color:#0fb6fe;font-weight: bold"
                  icon="chevron-left"
                  aria-label="Page Left"
              />
            </b-button>
          </b-button-group>
          <b-button-group class="mx-1">
            <h4>
              {{idx + 1 }} of  {{maxWords}}
            </h4>
          </b-button-group>
          <b-button-group
              class="mx-1">
            <b-button
                style="float: left; background-color: white; color: #13b7fe; border-radius: 10px"
                :disabled="idx == maxWords - 1"
                @click="handlePageTo(idx + 1)"
            >
              <b-icon
                  style="color:#0fb6fe;font-weight: bold"
                  icon="chevron-right"
                  aria-label="Page Right"
              />
            </b-button>
          </b-button-group>
        </b-button-toolbar>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateFormatToggle from "@/components/common/dateFormatToggle";
export default {
  name: "Display_PaneResponse_Situation",
  components: {
    DateFormatToggle
  },
  created(){},
  mounted() {},
  props: {
    situation: {
      type: String,
      required: false,
      default:""
    },
    isPrivate: {
      type: Boolean,
      default:false
    },
    date: {
      type: Object,
      required: false,
      default: ()=>{
        return {};
      }
    },
    idx: {
      type: Number,
      required: false,
      default: 0
    },
    maxWords: {
      type: Number,
      required: true,
      default: 0
    },
  },
  computed: {},
  methods: {
    handlePageTo(pageNumber){
      this.$emit('page-to', pageNumber)
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
